import React, { useState } from 'react';
import './App.css';
import emailjs from 'emailjs-com';

const PASSWORD_HASH = '4497b6d642dd361c23a9a7ec2f10a0e5248dcff52799481ff963ee014db40a49';
const EMAILJS_SERVICE_ID = 'service_h4993d5';
const EMAILJS_TEMPLATE_ID = 'template_rhz1h9a';
const EMAILJS_USER_ID = 'vSoUROePz8TgpIs5y';

const presents = [
  { title: 'Apsipirk mytheresa.com', img: process.env.PUBLIC_URL + '/image/mytheresa.png', description: 'A luxury fashion gift card for shopping at mytheresa.com.' },
  { title: 'Atostogos kuboje', img: process.env.PUBLIC_URL + '/image/vacation-in-cuba.png', description: 'A dream vacation in Cuba with sun, sea, and adventure.' },
  { title: 'Kvepalai', img: process.env.PUBLIC_URL + '/image/creme-de-la-creme.png', description: 'Exclusive perfume from Creme de la Creme.' },
  { title: 'Aura ring', img: process.env.PUBLIC_URL + '/image/aura-ring.png', description: 'A smart ring for health and wellness tracking.' },
];

function App() {
  const [selected, setSelected] = useState(null);
  const [unlocked, setUnlocked] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(null);

  async function checkPassword(e) {
    e.preventDefault();
    const enc = new TextEncoder();
    const data = enc.encode(input);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    if (hashHex === PASSWORD_HASH) {
      setUnlocked(true);
      setError('');
    } else {
      setError('Incorrect password');
    }
  }

  const handleOrder = () => {
    setSending(true);
    setSent(null);
    emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        gift_title: selected.title,
      },
      EMAILJS_USER_ID
    )
      .then(() => {
        setSending(false);
        setSent('success');
      })
      .catch(() => {
        setSending(false);
        setSent('fail');
      });
  };

  if (!unlocked) {
    return (
      <div className="App" style={{justifyContent: 'center', alignItems: 'center'}}>
        <form onSubmit={checkPassword} className="password-form">
          <input
            type="password"
            value={input}
            onChange={e => setInput(e.target.value)}
            placeholder="Pasakyk Ka Mėgsti"
            className="password-input"
          />
          <button type="submit" className="order-btn">Unlock</button>
          {error && <div style={{color: 'red', marginTop: '1rem'}}>{error}</div>}
        </form>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="cards-container">
        {presents.map((present, idx) => (
          <div className="present-card" key={idx} onClick={() => { setSelected(present); setSent(null); }}>
            <img src={present.img} alt={present.title} className="present-img" />
            <div>{present.title}</div>
          </div>
        ))}
      </div>
      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <img src={selected.img} alt={selected.title} className="modal-img" />
            <h2>{selected.title}</h2>
            <p>{selected.description}</p>
            <button className="order-btn" onClick={handleOrder} disabled={sending}>
              {sending ? 'Sending...' : 'Order this present'}
            </button>
            {sent === 'success' && <div style={{color: 'green', marginTop: '1rem'}}>Order email sent!</div>}
            {sent === 'fail' && <div style={{color: 'red', marginTop: '1rem'}}>Failed to send email. Try again.</div>}
            <button className="close-btn" onClick={() => setSelected(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
